export default "__VITE_ASSET__BL$J1rHh__"